module.exports = __webpack_public_path__ + "static/media/tapir-brown.2d1a4f30.png";